import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './AnnouncementModal.css';

const AnnouncementModal = ({ isOpen, onClose, announcement }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  if (!isOpen || !announcement) return null;

  const { title, message, type, url, image } = announcement;

  const handleAction = () => {
    navigate('/social/announcement');
    onClose();
  };

  const getBadgeClass = () => {
    switch (type) {
      case 'success': return 'badge-success';
      case 'warning': return 'badge-warning';
      case 'error': return 'badge-error';
      default: return 'badge-info';
    }
  };

  const getHeaderClass = () => {
    switch (type) {
      case 'success': return 'header-success';
      case 'warning': return 'header-warning';
      case 'error': return 'header-error';
      default: return 'header-info';
    }
  };

  return (
    <div className="announcement-modal-overlay">
      <div
        className="announcement-modal"
        onClick={(e) => e.stopPropagation()}
        dir={i18n.dir()}
      >
        <div className="announcement-modal-header">
          <div className={`announcement-modal-image-container ${getHeaderClass()}`}>
            {image ? (
              <img src={image} alt="Announcement" className="announcement-modal-image" />
            ) : (
              <div className="announcement-modal-illustration">
                <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.8)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                  <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                </svg>
              </div>
            )}
          </div>
        </div>

        <div className="announcement-modal-content">
          <span className={`announcement-modal-type-badge ${getBadgeClass()}`}>
            {type || 'System'}
          </span>
          <h2 className="announcement-modal-title">
            {title || t('common.announcement')}
          </h2>
          <p className="announcement-modal-message">
            {message}
          </p>

          <div className="announcement-modal-actions">
            {url && (
              <button
                className="announcement-modal-btn announcement-modal-btn-primary"
                onClick={handleAction}
              >
                {t('common.learnMore') || 'Learn More'}
              </button>
            )}
            <button
              className="announcement-modal-btn announcement-modal-btn-secondary"
              onClick={onClose}
            >
              {t('common.close') || 'Close'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementModal;
